var _path, _rect, _rect2, _rect3, _rect4, _mask, _rect5, _mask2, _rect6, _mask3, _rect7, _mask4, _rect8, _mask5, _rect9, _mask6, _rect10, _mask7, _rect11, _mask8, _rect12, _mask9, _rect13, _mask10, _rect14, _mask11, _rect15, _mask12, _rect16, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuickReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 120,
    viewBox: "0 0 168 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5466 47.0487L30.4154 44.9304V47.9353V65.4206V66.6706H31.6654H49.2574H52.2881L50.1385 64.534L32.5466 47.0487ZM10.5551 64.1706H9.30515V65.4206V68.9176V70.1676H10.5551H21.1103H22.3603V68.9176V65.4206V64.1706H21.1103H10.5551ZM10.5551 78.25H9.30515V79.5V82.9059V84.1559H10.5551H45.739H46.989V82.9059V79.5V78.25H45.739H10.5551ZM10.5551 92.25H9.30515V93.5V96.8941V98.1441H10.5551H45.739H46.989V96.8941V93.5V92.25H45.739H10.5551ZM53.3519 107.947C52.2672 109.025 50.7945 109.632 49.2574 109.632H7.03676C5.49957 109.632 4.02687 109.025 2.94221 107.947C1.85782 106.869 1.25 105.409 1.25 103.888V47.9353C1.25 46.4143 1.85782 44.9541 2.94221 43.8763C4.02687 42.7982 5.49958 42.1912 7.03676 42.1912H34.6683L55.0441 62.4435V103.888C55.0441 105.409 54.4363 106.869 53.3519 107.947Z",
    fill: "#E4A370",
    stroke: "#E4A370",
    strokeWidth: 2.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.1912,
    y: 14.897,
    width: 123.735,
    height: 77.6765,
    rx: 3.75,
    fill: "white",
    stroke: "#E4A370",
    strokeWidth: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66.0734,
    y: 1.25,
    width: 7.73529,
    height: 24.7941,
    rx: 2.75,
    fill: "white",
    stroke: "#E4A370",
    strokeWidth: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 134.309,
    y: 1.25,
    width: 7.73529,
    height: 24.7941,
    rx: 2.75,
    fill: "white",
    stroke: "#E4A370",
    strokeWidth: 2.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40.9412,
    y: 34.1176,
    width: 124.529,
    height: 3.41176,
    fill: "#E4A370"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1_191_3033",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.8822,
    y: 42.6471,
    width: 18.7647,
    height: 10.2353,
    rx: 1
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52.8822,
    y: 42.6471,
    width: 18.7647,
    height: 10.2353,
    rx: 1,
    fill: "white",
    stroke: "#E4A370",
    strokeWidth: 5,
    mask: "url(#path-6-inside-1_191_3033)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-2_191_3033",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.1764,
    y: 42.647,
    width: 18.7647,
    height: 10.2353,
    rx: 1
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 80.1764,
    y: 42.647,
    width: 18.7647,
    height: 10.2353,
    rx: 1,
    fill: "white",
    stroke: "#E4A370",
    strokeWidth: 5,
    mask: "url(#path-7-inside-2_191_3033)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-3_191_3033",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.47,
    y: 42.647,
    width: 18.7647,
    height: 10.2353,
    rx: 1
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 107.47,
    y: 42.647,
    width: 18.7647,
    height: 10.2353,
    rx: 1,
    fill: "white",
    stroke: "#E4A370",
    strokeWidth: 5,
    mask: "url(#path-8-inside-3_191_3033)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-4_191_3033",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.765,
    y: 42.647,
    width: 18.7647,
    height: 10.2353,
    rx: 1
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 134.765,
    y: 42.647,
    width: 18.7647,
    height: 10.2353,
    rx: 1,
    fill: "white",
    stroke: "#E4A370",
    strokeWidth: 5,
    mask: "url(#path-9-inside-4_191_3033)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-5_191_3033",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.8822,
    y: 76.7647,
    width: 18.7647,
    height: 10.2353,
    rx: 1
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 52.8822,
    y: 76.7647,
    width: 18.7647,
    height: 10.2353,
    rx: 1,
    fill: "white",
    stroke: "#E4A370",
    strokeWidth: 5,
    mask: "url(#path-10-inside-5_191_3033)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-6_191_3033",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.1764,
    y: 76.7647,
    width: 18.7647,
    height: 10.2353,
    rx: 1
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 80.1764,
    y: 76.7647,
    width: 18.7647,
    height: 10.2353,
    rx: 1,
    fill: "white",
    stroke: "#E4A370",
    strokeWidth: 5,
    mask: "url(#path-11-inside-6_191_3033)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-7_191_3033",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.47,
    y: 76.7647,
    width: 18.7647,
    height: 10.2353,
    rx: 1
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 107.47,
    y: 76.7647,
    width: 18.7647,
    height: 10.2353,
    rx: 1,
    fill: "white",
    stroke: "#E4A370",
    strokeWidth: 5,
    mask: "url(#path-12-inside-7_191_3033)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-8_191_3033",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.765,
    y: 76.7647,
    width: 18.7647,
    height: 10.2353,
    rx: 1
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 134.765,
    y: 76.7647,
    width: 18.7647,
    height: 10.2353,
    rx: 1,
    fill: "white",
    stroke: "#E4A370",
    strokeWidth: 5,
    mask: "url(#path-13-inside-8_191_3033)"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-9_191_3033",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.8822,
    y: 59.7059,
    width: 18.7647,
    height: 10.2353,
    rx: 1
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 52.8822,
    y: 59.7059,
    width: 18.7647,
    height: 10.2353,
    rx: 1,
    fill: "white",
    stroke: "#E4A370",
    strokeWidth: 5,
    mask: "url(#path-14-inside-9_191_3033)"
  })), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-10_191_3033",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.1764,
    y: 59.7059,
    width: 18.7647,
    height: 10.2353,
    rx: 1
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 80.1764,
    y: 59.7059,
    width: 18.7647,
    height: 10.2353,
    rx: 1,
    fill: "white",
    stroke: "#E4A370",
    strokeWidth: 5,
    mask: "url(#path-15-inside-10_191_3033)"
  })), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-11_191_3033",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.47,
    y: 59.7059,
    width: 18.7647,
    height: 10.2353,
    rx: 1
  }))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 107.47,
    y: 59.7059,
    width: 18.7647,
    height: 10.2353,
    rx: 1,
    fill: "white",
    stroke: "#E4A370",
    strokeWidth: 5,
    mask: "url(#path-16-inside-11_191_3033)"
  })), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-12_191_3033",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.765,
    y: 59.7059,
    width: 18.7647,
    height: 10.2353,
    rx: 1
  }))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 134.765,
    y: 59.7059,
    width: 18.7647,
    height: 10.2353,
    rx: 1,
    fill: "white",
    stroke: "#E4A370",
    strokeWidth: 5,
    mask: "url(#path-17-inside-12_191_3033)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3472 89.366V89.3663V101.558V102.808L23.0977 102.808L18.7304 102.81H18.7302C18.3183 102.81 17.9122 102.936 17.5633 103.177C17.2138 103.418 16.9358 103.764 16.7701 104.177C16.6043 104.59 16.5603 105.046 16.6453 105.487C16.7302 105.928 16.939 106.327 17.2394 106.637L24.3472 89.366ZM24.3472 89.366C24.347 88.7909 24.5579 88.2434 24.9278 87.832L23.9982 86.9963L24.9278 87.832C25.291 87.4279 25.7795 87.1854 26.2946 87.1393L26.4963 87.1324H33.2301C33.7817 87.1324 34.3188 87.358 34.721 87.7729C35.1245 88.1891 35.3577 88.7616 35.3577 89.3663V101.558V102.808L36.6072 102.808L40.9745 102.81H40.9747C41.3583 102.81 41.7372 102.919 42.0698 103.129C42.3978 103.336 42.6699 103.635 42.8529 103.996L42.9452 104.199C43.1035 104.606 43.1442 105.054 43.0607 105.486C42.9756 105.927 42.7666 106.327 42.4658 106.637L42.4655 106.637L31.3431 118.11C30.9409 118.524 30.4039 118.75 29.8525 118.75C29.3011 118.75 28.7641 118.525 28.362 118.11C28.3619 118.11 28.3619 118.11 28.3618 118.11L17.2396 106.637L24.3472 89.366Z",
    fill: "#E4A370",
    stroke: "white",
    strokeWidth: 2.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickReport);
export default __webpack_public_path__ + "static/media/quick_report.5c553c073a299d9e21abd24c39e21efe.svg";
export { ForwardRef as ReactComponent };